export const en: any = {
    temppu: '',
    temppa: '',
    1005: -1
};